
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entdecken",
      function () {
        return require("private-next-pages/entdecken.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/entdecken"])
      });
    }
  